import { useTranslation } from 'react-i18next'

import { FormikField, getFormikFormFieldErrorProps } from '../../../Formik'
import { TextareaOutlineField } from '../../../Textarea'

function EmailAddNoteActionModalFields({ noteProps }) {
  const { t } = useTranslation()

  return (
    <FormikField
      {...noteProps}
      clearable
      Component={TextareaOutlineField}
      getErrorProps={getFormikFormFieldErrorProps}
      placeholder={t('Modal.EmailAddNotePlaceholderKey')}
    />
  )
}

export default EmailAddNoteActionModalFields
